import React from 'react';
import ErrorMessage from '../Common/ErrorMessage';
import { REPLY_DID_NOT_ARRIVE_MESSAGE, REPLY_STOPPED_EARLY_MESSAGE } from '../../utils/betaAllowance';
import { asChatText } from '../../utils/streamingReplyDisplay';

/**
 * A throw inside one row stays in that row. The rest of the thread,
 * and the composer outside this boundary, keep rendering.
 */
class ChatErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error('Chat render failed', error);
  }

  retry = () => {
    this.setState({ failed: false });
    if (this.props.onRetry) this.props.onRetry();
  };

  render() {
    if (this.state.failed) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <ErrorMessage
          message={REPLY_DID_NOT_ARRIVE_MESSAGE}
          onRetry={this.retry}
        />
      );
    }
    return this.props.children;
  }
}

export function messageRowFallback(message) {
  const text = asChatText(message?.content);
  const assistant = message?.speaker !== 'user';
  return (
    <div
      id={message?.id ? `message-${message.id}` : undefined}
      className={`chat-message ${assistant ? 'chat-message--assistant' : 'chat-message--user'}`}
    >
      {text ? <div className="chat-message__content">{text}</div> : null}
      {assistant ? (
        <p className="chat-message__stopped" role="status">{REPLY_STOPPED_EARLY_MESSAGE}</p>
      ) : null}
    </div>
  );
}

export default ChatErrorBoundary;
